// ----------------------------------------------------------------------
// V2 Modern Input Styling

import { alpha } from '@mui/material/styles';

export default function Input(theme) {
  const primaryMain = '#7635dc';

  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            '& svg': { color: theme.palette.text.disabled }
          }
        },
        input: {
          '&::placeholder': {
            opacity: 1,
            color: theme.palette.text.disabled
          }
        }
      }
    },
    MuiInput: {
      styleOverrides: {
        underline: {
          '&:before': {
            borderBottomColor: theme.palette.grey[500_56]
          }
        }
      }
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          backgroundColor: alpha(primaryMain, 0.04),
          '&:hover': {
            backgroundColor: alpha(primaryMain, 0.08)
          },
          '&.Mui-focused': {
            backgroundColor: alpha(primaryMain, 0.08)
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground
          }
        },
        underline: {
          '&:before': {
            borderBottomColor: 'transparent'
          },
          '&:after': {
            borderBottomColor: primaryMain
          }
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: theme.shape.borderRadius,
          backgroundColor: alpha(primaryMain, 0.02),
          transition: 'all 0.2s ease-in-out',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'transparent',
            transition: 'border-color 0.2s ease-in-out'
          },
          '&:hover': {
            backgroundColor: alpha(primaryMain, 0.04),
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: alpha(primaryMain, 0.2)
            }
          },
          '&.Mui-focused': {
            backgroundColor: alpha(primaryMain, 0.04),
            boxShadow: theme.customShadows.v2?.inputFocus,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: primaryMain,
              borderWidth: 2
            }
          },
          '&.Mui-disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: theme.palette.action.disabledBackground
            }
          }
        }
      }
    },
    MuiTextField: {
      defaultProps: {
        variant: 'outlined'
      }
    }
  };
}
